module.exports = __webpack_public_path__ + "img/no-loop.edb32fff.png";